<template>
  <div
    :class="[
      'v-content',
      'container-fluid'
    ]">
    <div class="row v-content__container py-4 py-sm-5 my-4 my-sm-5">
      <div v-if="hasSidebar" class="col-md-3 d-none d-md-flex">
        <slot name="sidebar"></slot>
      </div>
      <div class="col">
        <main>
          <slot></slot>
        </main>
      </div>
      <div v-if="!fullWidth" class="col-md-1 col-lg-2 d-none d-md-flex"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fullWidth: {
      type: Boolean,
      default: false
    },
    back: {
      type: Object,
      default: null
    },
    speech: {
      type: Object,
      default: null
    }
  },
  computed: {
    hasSidebar() {
      return !!this.$slots.sidebar;
    }
  }
};
</script>
